export default __webpack_public_path__ + "static/media/title_page3.56dc6daa.png";